<template>
  <a-tag :color="color">{{ status }}</a-tag>
</template>

<script>
export default {
  props: {
    status: String,
    color: String,
  },
};
</script>
